import * as React from "react"
import {FlagsIconSeeker, ToggleButtonSeeker} from "@ui-seeker/core";
import {Box} from "@mui/material";


export default function PriceDiscountTopMarketChangesTableActions({ selectedCountry, countries, onClick }) {

    return <ToggleButtonSeeker
        value={selectedCountry}
        onChange={(_, newValue) => onClick(newValue)}
		tabs={countries.map(countryName => ({
			label: <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				<FlagsIconSeeker countryName={countryName} /> {countryName.toUpperCase()}
			</Box>,
			value: countryName
		}))}
    />
}